export function PopoverHandler() {
  function showPopover(popover) {
    $(popover).popover("show")

    setTimeout(() => {
      $(popover).popover("hide")
    }, 2000)
  }

  return {
    showPopover,
  }
}